import { useMemo } from 'react'
import { LabRemoteConfigKeys } from 'constants/lab'
import { useLabRemoteConfig } from 'hooks/FeatureFlag/useLabRemoteConfig'
import { isLabLEBTSocieteCampaignPayload } from 'loyalty/societeCampaign/societeCampaignTypes'

/**
 * Based on `src/loyalty/hooks/useTierUpgradeCampaign.ts` in www-le-customer.
 * Renamed to match LEBT's société campaign feature.
 */
function useSocieteCampaign(slug: string): App.SocieteCampaignPayload | undefined {
  const remoteConfig = useLabRemoteConfig(LabRemoteConfigKeys.societeCampaign)

  return useMemo(() => {
    if (!remoteConfig || remoteConfig.error) return undefined
    const value = remoteConfig.value

    if (!Array.isArray(value)) {
      if (!isLabLEBTSocieteCampaignPayload(value)) return undefined
      return value.slug === slug ? value : undefined
    }

    for (const entry of value) {
      if (!isLabLEBTSocieteCampaignPayload(entry)) continue
      if (entry.slug !== slug) continue
      return entry
    }

    return undefined
  }, [remoteConfig, slug])
}

export default useSocieteCampaign
